import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  entryExitStatuses: [],
  selectedEntryExitStatus: null,
  loading: false,
  error: null,
  successMessage: null,
  // Pagination
  page: 1,
  pageSize: 10,
  total: 0,
  // Sorting
  sortColumn: 'name',
  sortDirection: 'asc',
  // Filtering
  filterName: '',
};

const entryExitStatusesSlice = createSlice({
  name: 'entryExitStatuses',
  initialState,
  reducers: {
    // Fetch entry exit statuses
    fetchEntryExitStatuses: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchEntryExitStatusesSuccess: (state, action) => {
      state.loading = false;
      state.entryExitStatuses = action.payload.data;
      state.total = action.payload.meta.total;
      state.error = null;
    },
    fetchEntryExitStatusesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch entry exit status by ID
    fetchEntryExitStatusById: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchEntryExitStatusByIdSuccess: (state, action) => {
      state.loading = false;
      state.selectedEntryExitStatus = action.payload;
      state.error = null;
    },
    fetchEntryExitStatusByIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Add entry exit status
    addEntryExitStatus: (state) => {
      state.loading = true;
      state.error = null;
    },
    addEntryExitStatusSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    addEntryExitStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update entry exit status
    updateEntryExitStatus: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateEntryExitStatusSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    updateEntryExitStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete entry exit status
    deleteEntryExitStatus: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteEntryExitStatusSuccess: (state, action) => {
      state.loading = false;
      state.entryExitStatuses = state.entryExitStatuses.filter((ees) => ees.id !== action.payload);
      state.error = null;
      state.successMessage = action.payload.message;
    },
    deleteEntryExitStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Bulk delete
    bulkDeleteEntryExitStatuses: (state) => {
      state.loading = true;
      state.error = null;
    },
    bulkDeleteEntryExitStatusesSuccess: (state, action) => {
      state.loading = false;
      state.entryExitStatuses = state.entryExitStatuses.filter((ees) => !action.payload.includes(ees.id));
      state.error = null;
      state.successMessage = action.payload.message;
    },
    bulkDeleteEntryExitStatusesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Pagination
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1;
    },

    // Sorting
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },

    // Filtering
    setFilterName: (state, action) => {
      state.filterName = action.payload;
      state.page = 1;
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchEntryExitStatuses,
  fetchEntryExitStatusesSuccess,
  fetchEntryExitStatusesFailure,
  fetchEntryExitStatusById,
  fetchEntryExitStatusByIdSuccess,
  fetchEntryExitStatusByIdFailure,
  addEntryExitStatus,
  addEntryExitStatusSuccess,
  addEntryExitStatusFailure,
  updateEntryExitStatus,
  updateEntryExitStatusSuccess,
  updateEntryExitStatusFailure,
  deleteEntryExitStatus,
  deleteEntryExitStatusSuccess,
  deleteEntryExitStatusFailure,
  bulkDeleteEntryExitStatuses,
  bulkDeleteEntryExitStatusesSuccess,
  bulkDeleteEntryExitStatusesFailure,
  setPage,
  setPageSize,
  setSortColumn,
  setSortDirection,
  setFilterName,
  clearError,
  clearSuccessMessage,
} = entryExitStatusesSlice.actions;

// Selectors
export const selectEntryExitStatuses = (state) => state.entryExitStatuses?.entryExitStatuses || [];
export const selectSelectedEntryExitStatus = (state) => state.entryExitStatuses?.selectedEntryExitStatus;
export const selectEntryExitStatusesLoading = (state) => state.entryExitStatuses?.loading || false;
export const selectEntryExitStatusesError = (state) => state.entryExitStatuses?.error;
export const selectEntryExitStatusesSuccessMessage = (state) => state.entryExitStatuses?.successMessage;
export const selectEntryExitStatusesTotal = (state) => state.entryExitStatuses?.total || 0;
export const selectEntryExitStatusesPage = (state) => state.entryExitStatuses?.page || 1;
export const selectEntryExitStatusesPageSize = (state) => state.entryExitStatuses?.pageSize || 10;
export const selectEntryExitStatusesSortColumn = (state) => state.entryExitStatuses?.sortColumn || 'name';
export const selectEntryExitStatusesSortDirection = (state) => state.entryExitStatuses?.sortDirection || 'asc';
export const selectEntryExitStatusesFilterName = (state) => state.entryExitStatuses?.filterName || '';

export default entryExitStatusesSlice.reducer;

